import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Star, GraduationCap, Briefcase, Home } from 'lucide-react';

const Tarifas = () => {
  return (
    <div className="pt-32 pb-20 min-h-screen" style={{ backgroundColor: 'var(--color-cream)' }}>
      <div className="container mx-auto px-6">
        
        <header className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#2D3319', fontFamily: "'Playfair Display', serif" }}>
            Tarifas Graciosenea
          </h1>
          <p className="text-xl max-w-2xl mx-auto" style={{ color: '#5A5F4D' }}>
            Diferentes formas de vivir el Baztán: desde el descanso absoluto hasta la convivencia colaborativa.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
          
          {/* 1. CASA COMPLETA */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col transition-all hover:shadow-2xl">
            <div className="p-6 flex-grow">
              <div className="flex justify-between items-start mb-4">
                <Home className="text-[#9B2C2C]" size={28} />
                <span className="text-[#9B2C2C] font-bold text-[10px] tracking-widest uppercase">Hasta 11 personas</span>
              </div>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Casa Completa</h3>
              <div className="flex items-baseline gap-1 mb-4">
                <span className="text-3xl font-bold text-[#9B2C2C]">275€</span>
                <span className="text-sm text-[#5A5F4D]">/noche</span>
              </div>
              <p className="text-xs text-gray-600 mb-6 leading-relaxed">
                Disfruta de la casa en exclusividad. Ideal para familias o grupos que buscan intimidad total en un entorno histórico.
              </p>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Uso exclusivo total</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Cocina histórica equipada</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Desayuno casero incluido</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Acceso a jardín y salones</li>
              </ul>
            </div>
            <div className="p-6 pt-0 mt-auto">
              <Link to="/contacto" className="block text-center py-3 bg-[#9B2C2C] text-white rounded-xl font-bold text-sm hover:bg-[#7d2323] transition-all">Reservar casa</Link>
            </div>
          </div>

          {/* 2. HABITACIÓN DOBLE */}
          <div className="bg-white rounded-2xl shadow-xl border-2 border-[#8B9A8E]/20 flex flex-col transition-all hover:shadow-2xl">
            <div className="p-6 flex-grow">
              <div className="flex justify-between items-start mb-4">
                <Star className="text-[#8B9A8E]" size={28} />
                <span className="text-[#8B9A8E] font-bold text-[10px] tracking-widest uppercase">Por habitación</span>
              </div>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Habitación Doble</h3>
              <div className="flex items-baseline gap-1 mb-4">
                <span className="text-3xl font-bold text-[#2D3319]">70€</span>
                <span className="text-sm text-[#5A5F4D]">/noche</span>
              </div>
              
              <ul className="space-y-3 text-sm mb-6">
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#8B9A8E] mt-1 flex-shrink-0" /> Mobiliario y suelos de época</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#8B9A8E] mt-1 flex-shrink-0" /> Desayuno incluido</li>
                <li className="flex items-start gap-2 text-[#2D3319] italic"><CheckCircle2 size={16} className="text-[#8B9A8E] mt-1 flex-shrink-0" /> Cama supletoria 20€ (máx. 2)</li>
              </ul>
              
              <div className="bg-[#F5F2ED] rounded-xl p-3 border border-[#8B9A8E]/30 text-center">
                <p className="text-[11px] font-bold text-[#2D3319] uppercase mb-1">¿Sois más de 5?</p>
                <p className="text-[#9B2C2C] font-bold text-sm">Solo 25€/persona</p>
                <p className="text-[10px] text-gray-500">en habitación doble</p>
              </div>
            </div>
            <div className="p-6 pt-0 mt-auto">
              <Link to="/contacto" className="block text-center py-3 border-2 border-[#2D3319] text-[#2D3319] rounded-xl font-bold text-sm hover:bg-[#2D3319] hover:text-white transition-all">Reservar ahora</Link>
            </div>
          </div>

          {/* 3. APRENDIZAJE */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col transition-all hover:shadow-2xl">
            <div className="p-6 flex-grow">
              <div className="flex justify-between items-start mb-4">
                <GraduationCap className="text-[#9B2C2C]" size={28} />
                <span className="text-[#9B2C2C] font-bold text-[10px] tracking-widest uppercase">Experiencia Vital</span>
              </div>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Aprendizaje</h3>
              <div className="flex items-baseline gap-1 mb-4">
                <span className="text-3xl font-bold text-[#9B2C2C]">40€</span>
                <span className="text-sm text-[#5A5F4D]">/noche</span>
              </div>
              <p className="text-xs text-gray-600 mb-6 leading-relaxed">
                Una inmersión en la vida rural. Participa, aprende y convive mientras disfrutas de una estancia con sentido.
              </p>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Pensión completa</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Talleres y actividades</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Cocina colaborativa</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Espacios compartidos</li>
              </ul>
            </div>
            <div className="p-6 pt-0 mt-auto">
              <Link to="/aprendizaje-colaborativo" className="block text-center py-3 bg-[#8B9A8E] text-white rounded-xl font-bold text-sm hover:bg-[#6e7a70] transition-all">Saber más</Link>
            </div>
          </div>

          {/* 4. PROFESIONALES */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col transition-all hover:shadow-2xl">
            <div className="p-6 flex-grow">
              <div className="flex justify-between items-start mb-4">
                <Briefcase className="text-[#9B2C2C]" size={28} />
                <span className="text-[#9B2C2C] font-bold text-[10px] tracking-widest uppercase">Coworking & Retiros</span>
              </div>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#2D3319' }}>Profesionales</h3>
              <div className="mt-2 mb-4">
                <span className="text-2xl font-bold text-[#2D3319] uppercase">Consultar</span>
              </div>
              <p className="text-xs text-gray-600 mb-6 leading-relaxed">
                El lugar perfecto para desconectar del ruido y conectar con el equipo o con tu propia creatividad.
              </p>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Espacios de coworking</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Eventos y rodajes</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Conexión alta velocidad</li>
                <li className="flex items-start gap-2 text-[#2D3319]"><CheckCircle2 size={16} className="text-[#9B2C2C] mt-1 flex-shrink-0" /> Catering bajo petición</li>
              </ul>
            </div>
            <div className="p-6 pt-0 mt-auto">
              <Link to="/profesionales" className="block text-center py-3 border-2 border-[#8B9A8E] text-[#8B9A8E] rounded-xl font-bold text-sm hover:bg-[#8B9A8E] hover:text-white transition-all">Ver opciones</Link>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Tarifas;